export default __webpack_public_path__ + "0db5a19027005f6c925da77a4169d0ab.svg";